import { defineGameCard, oncePerRound, roundMarkerStatus, } from '../authoring/index.js';
const REFLECTION_ROUND_KEY = '@cards/ability/crooked_mirror/damage_reflection/round';
export const CrookedMirrorCard = defineGameCard({
    id: 'crooked_mirror',
    gameplay: { type: 'STRUCTURE', cost: 3, baseStats: { attack: 0, health: 4 } },
    presentation: {
        name: 'Кривое зеркало',
        description: 'Первый раз за раунд, когда получает боевой урон от карты противника, наносит источнику на 1 больше полученного урона.',
        glyph: {
            colors: ['#10213A', '#B53038', '#361924', '#7C8C9C', '#A6BBCB'],
            rows: [
                '........1111........',
                '......11222211......',
                '.....1222222221.....',
                '....122344453221....',
                '....123444555321....',
                '...12344455554321...',
                '...12444555544421...',
                '..1224455554444221..',
                '..1224555544444221..',
                '..1224554444454221..',
                '..1225554444554221..',
                '..1224544444554221..',
                '..1224444455554221..',
                '...12444455554421...',
                '...12344455544321...',
                '....123555544321....',
                '....122355443221....',
                '....12223333222.....',
                '.....111222211......',
                '........1111........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        oncePerRound({
            abilityId: 'damage_reflection',
            trigger: 'onAttacked',
            when(ctx, event) {
                const self = ctx.self;
                if (self === undefined
                    || event.target.kind !== 'unit'
                    || event.target.instanceId !== self.id
                    || event.amount <= 0)
                    return false;
                const source = ctx.q.allUnits().find((unit) => unit.id === event.attackerId);
                return source !== undefined && source.controllerId !== self.controllerId;
            },
            run(ctx, event) {
                ctx.ops.dealDamage({ kind: 'unit', instanceId: event.attackerId }, event.amount + 1);
            },
        }),
    ],
    ui: {
        publicVars: {
            reflectionRound: { key: REFLECTION_ROUND_KEY, kind: 'number' },
        },
        statusProviders: [roundMarkerStatus({
                fact: 'reflectionRound',
                id: 'crooked-mirror-used',
                symbol: '↩',
                label: 'Отражение использовано',
                description: 'Зеркало уже отражало боевой урон в этом раунде.',
                tone: 'negative',
            })],
    },
});
//# sourceMappingURL=crooked_mirror.js.map